import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { CwActionIcon } from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';

import { NotificationType } from '../../../../definitions/enums/notifications/notification-type.enum';
import { NotificationData } from '../../../../definitions/interfaces/notifications/notification-data';
import { NotificationNavigationService } from '../../../../services/notifications/notification-navigation.service';
import { UserConfigsStoreFacade } from '../../../../stores/global-store/user-configs/user-configs-store.facade';
import {
  NotificationsStoreService
} from '../../../../stores/signal-stores/notifications-store/notifications-store.service';
import { NotificationIconPipe } from '../pipes/notification-icon/notification-icon.pipe';
import { NotificationInfoTextKeyPipe } from '../pipes/notification-info-text-key/notification-info-text-key.pipe';

@Component({
  selector: 'app-notification-row',
  imports: [
    TranslocoDirective,
    MatIcon,
    MatTooltip,
    NotificationIconPipe,
    NotificationInfoTextKeyPipe,
    CwActionIcon
  ],
  templateUrl: './notification-row.component.html',
  styleUrl: './notification-row.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationRowComponent {
  public notificationData = input.required<NotificationData>();
  public compactMode = input<boolean>(false);

  protected readonly userConfigsFacade = inject(UserConfigsStoreFacade);

  public notificationDataRPId = computed(
    () => this.notificationData().content?.replenishmentProcess?.processId ?? ''
  );
  public notificationDataOrderNumber = computed(
    () => this.notificationData().content?.erpOrderNumber ?? ''
  );
  public notificationId = computed(
    () => this.notificationData().id
  );
  public isNotificationDataRead = computed(() =>
    this.notificationData().isRead
  );
  public notificationDataCustomerName = computed(() =>
    this.notificationData().customer.name
  );
  public notificationDataType = computed(() =>
    this.notificationData().notificationType
  );
  public hideNotificationTooltip = true;

  protected notificationStore = inject(NotificationsStoreService);
  protected notificationNavigationService = inject(NotificationNavigationService);
  protected readonly notificationType = NotificationType;

  public onNotificationReadChange(): void {
    this.notificationStore.updateNotification(
      { notificationId: this.notificationId(), isRead: !this.isNotificationDataRead() }
    );
  }

  public onNotificationTextHover(elementRef: HTMLElement): void {
    this.hideNotificationTooltip = true;
    if (elementRef) {
      this.hideNotificationTooltip = elementRef.clientHeight >= elementRef.scrollHeight;
    }
  }
}
